import type { StampMeta } from "./StampMeta";
import { BUNDLED_STAMPS } from "./bundled";

export class StampLibrary {
  private stamps = new Map<string, StampMeta>();

  constructor() {
    for (const s of BUNDLED_STAMPS) this.stamps.set(s.id, s);
  }

  all(): StampMeta[] {
    return [...this.stamps.values()];
  }

  byCategory(cat: StampMeta["category"]): StampMeta[] {
    return this.all().filter((s) => s.category === cat);
  }

  get(id: string): StampMeta | undefined {
    return this.stamps.get(id);
  }

  add(stamp: StampMeta): void {
    this.stamps.set(stamp.id, stamp);
  }

  remove(id: string): void {
    this.stamps.delete(id);
  }

  search(query: string): StampMeta[] {
    const q = query.toLowerCase();
    return this.all().filter(
      (s) =>
        s.name.toLowerCase().includes(q) ||
        s.tags.some((t) => t.toLowerCase().includes(q)) ||
        s.category.includes(q),
    );
  }
}
